export default "__VITE_ASSET__f8882f55__"